import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export type LoginGov = null | {
  clientId: string;
  authorizationEndpoint: string;
  tokenEndpoint: string;
  redirectUri: string;
  scope?: string;
  logoutEndpoint?: string;
  acr_values: string;
  logo?: string;
};

export type AppConfigState = {
  loginGov: LoginGov;
  autoSaveInterval?: number;
  maxFileSize?: number;
  maxTitleLength?: number;
  maxOptionLength?: number;
  maxFieldLabelLength?: number;
  maxMapsToFieldLength?: number;
  maxLookupCodeLength?: number;
  postToSam?: boolean;
  logo?: string;
};

const initialState: AppConfigState = {
  loginGov: null,
  autoSaveInterval: 60000,
  maxFileSize: 26214400,
  maxTitleLength: 256,
  maxOptionLength: 100,
  maxFieldLabelLength: 250,
  maxMapsToFieldLength: 100,
  maxLookupCodeLength: 250,
  postToSam: false,
  logo: "",
};

export const appConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  reducers: {
    setAppConfig: (state, action: PayloadAction<AppConfigState>) => {
      state.loginGov = action.payload.loginGov;
      state.autoSaveInterval = action.payload.autoSaveInterval;
      state.maxFileSize = action.payload.maxFileSize;
      state.maxTitleLength = action.payload.maxTitleLength;
      state.maxOptionLength = action.payload.maxOptionLength;
      state.maxFieldLabelLength = action.payload.maxFieldLabelLength;
      state.postToSam = action.payload.postToSam;
      state.logo = action.payload.logo;
    },
  },
});

export const { setAppConfig } = appConfigSlice.actions;

export const selectAppConfig = (state: RootState) => state.appConfig;
export const selectAppConfigMaxOption = (state: RootState) =>
  state.appConfig.maxOptionLength;

export default appConfigSlice.reducer;
